const ManuallyInputtedTransactionRefStatus = Object.freeze({
    OPTIONAL: 'optional',
    REQUIRED: 'required',
    UNSUPPORTED: 'unsupported',
});

module.exports = ManuallyInputtedTransactionRefStatus;
